import { TournamentDetailsData } from 'config/types/tournament'
import useModal from 'hooks/useModal'
import { RowBetween, RowCenter, RowMiddle } from 'layout/Components/Row'
import React, { useState } from 'react'
import styled from 'styled-components'
import { Icons } from 'svgs'
import Button from 'UIKit/Button'
import TransText from 'UIKit/Text/TransText'
import { CardSection, CardTitle } from 'views/Tournament'
import CircleProgressBar from './CircleProgressBar'
import LeaderBoardModal from './LeaderBoardModal'
import CompactTable from './LeaderBoardTable/CompactTable'

const LeaderBoard: React.FC<{ tournamentDetails: TournamentDetailsData }> = ({ tournamentDetails }) => {
  const [presentLeaderBoardModal] = useModal(LeaderBoardModal)
  const [retrievalTime, setRetrievalTime] = useState(0)

  const handleRefetch = () => {
    setRetrievalTime(Date.now())
  }

  return (
    <CardSection>
      <RowBetween mb="12px">
        <RowMiddle>
          <CardTitle marginRight="12px">Leaderboard</CardTitle>
          {tournamentDetails?.expiredTime > Date.now() && <CircleProgressBar triggerCallback={handleRefetch} />}
        </RowMiddle>

        <StyledFullboardBtn
          onClick={() => {
            presentLeaderBoardModal({
              tournamentDetails,
            })
          }}
        >
          <RowCenter>
            <TransText
              fontSize="12px"
              fontWeight={400}
              lineHeight="normal"
              letterSpacing={-0.28}
              color="#7A7A7A"
              mr="3px"
            >
              Full Board
            </TransText>
            <Icons.ChevronRightIcon fill="#7A7A7A" width="10px" height="12px" />
          </RowCenter>
        </StyledFullboardBtn>
      </RowBetween>

      <CompactTable tournamentDetails={tournamentDetails} retrievalTime={retrievalTime} />
    </CardSection>
  )
}

const StyledFullboardBtn = styled(Button)`
  padding: 0px;
  height: fit-content;
  background: none;
`

export default LeaderBoard
